import { render, staticRenderFns } from "./Combinant.vue?vue&type=template&id=39601a54&"
import script from "./Combinant.vue?vue&type=script&lang=ts&"
export * from "./Combinant.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports